/**
 * @generated SignedSource<<599d55fee81a02a6aaf62a5e625b6ddd>>
 * @relayHash 59c81584cbd2cc164000b6897e83d0b8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7f341057c760f4aae078dd67aac57ffbf214d101f22b50313c566bd001d07f0c

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiWrapperEditionAwarenessDropdownWrapperQuery } from './uiWrapperEditionAwarenessDropdownWrapperQuery.graphql';

const node: PreloadableConcreteRequest<uiWrapperEditionAwarenessDropdownWrapperQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "7f341057c760f4aae078dd67aac57ffbf214d101f22b50313c566bd001d07f0c",
    "metadata": {},
    "name": "uiWrapperEditionAwarenessDropdownWrapperQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
